import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'ag-common-svc/shared/shared.module';
import { ChangeLogPipesModule } from 'ag-common-svc/lib/components/changes-history-grid/pipes/change-log-pipes.module';
import { ChangeLogAgentPortalRoleComponent } from './change-log-agent-portal-role.component';

@NgModule({
  declarations: [ChangeLogAgentPortalRoleComponent],
  imports: [CommonModule, SharedModule, ChangeLogPipesModule],
  exports: [ChangeLogAgentPortalRoleComponent],
  providers: [],
})
export class ChangeLogAgentPortalRoleModule {}
